/* Art of Steam Co. — compare page. Rules: assets/aos-sizing.js */
(function () {
  function esc(v) { return String(v == null ? '' : v).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function fmt(n) { return Math.round(n).toLocaleString('en-US'); }
  var cache = {};

  // entries are "handle" or "handle|variantId"
  function fetchProduct(entry) {
    if (cache[entry]) return cache[entry];
    var parts = String(entry).split('|'), h = parts[0], v = parts[1];
    cache[entry] = fetch('/products/' + encodeURIComponent(h) + '?view=aos-compare' + (v ? '&variant=' + encodeURIComponent(v) : ''), { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (t) { var p = JSON.parse(t); p.key = entry; p.chosen = !!v; return p; })
      .catch(function () { return null; });
    return cache[entry];
  }

  function init(root) {
    var S = window.AOS.sizing, C = window.AOS.compare;
    var tabs = [].slice.call(root.querySelectorAll('[data-cat]'));
    var table = root.querySelector('[data-table]'), diff = root.querySelector('[data-diff]'), roomEl = root.querySelector('[data-room]');
    var editor = document.createElement('form');
    editor.className = 'aos-compare__editor card'; editor.id = root.id + '-room'; editor.hidden = true; editor.noValidate = true;
    root.querySelector('.aos-compare__bar').insertAdjacentElement('afterend', editor);

    // Room editor: same inputs as the calculators, saved to the shared room so product pages and calculators agree
    function sel(name, label, opts, val) {
      return '<label>' + label + '<select name="' + name + '">' + opts.map(function (o) { return '<option value="' + o[0] + '"' + (o[0] === val ? ' selected' : '') + '>' + o[1] + '</option>'; }).join('') + '</select></label>';
    }
    function dim(k, label, r) {
      var v = S.num(r[k]), ft = v > 0 ? Math.floor(v) : '', inch = v > 0 ? Math.round((v - Math.floor(v)) * 12) || '' : '';
      return '<div class="aos-compare__dim"><span class="aos-compare__dim-label">' + label + '</span>' +
        '<label><span class="visually-hidden">' + label + ' feet</span><input type="number" inputmode="numeric" min="0" step="1" name="' + k + 'ft" value="' + ft + '"> ft</label>' +
        '<label><span class="visually-hidden">' + label + ' inches</span><input type="number" inputmode="numeric" min="0" max="11" step="1" name="' + k + 'in" value="' + inch + '"> in</label></div>';
    }
    function buildEditor() {
      var r = S.loadRoom();
      var extra = cat === 'steam'
        ? sel('wall', 'Wall material', [['tile', 'Ceramic, porcelain or glass tile'], ['stone', 'Natural stone, marble or glass block']], r.wall || 'tile')
        : '<label>Glass (sq. ft.)<input type="number" inputmode="decimal" min="0" step="0.5" name="glass" value="' + (r.glass || 0) + '"></label>' +
          sel('insulation', 'Insulation', [['good', 'Good (fully insulated)'], ['fair', 'Fair (some gaps)'], ['poor', 'Poor (little or none)']], r.insulation || 'good') +
          sel('ceiling', 'Ceiling type', [['flat', 'Flat'], ['vaulted', 'Vaulted']], r.ceiling || 'flat');
      editor.innerHTML = '<div class="card__section"><div class="aos-compare__dims">' + dim('L', 'Length', r) + dim('W', 'Width', r) + dim('H', 'Ceiling height', r) + '</div>' +
        '<div class="aos-compare__extra">' + extra + '</div><p class="aos-compare__err" role="alert" hidden></p>' +
        '<div class="aos-compare__actions"><button type="submit" class="button button--primary button--small">Update comparison</button>' +
        '<button type="button" class="link" data-cancel>Cancel</button></div></div>';
    }
    editor.addEventListener('submit', function (e) {
      e.preventDefault();
      var f = editor.elements, r = S.loadRoom();
      var L = S.ftin(f.Lft.value, f.Lin.value), W = S.ftin(f.Wft.value, f.Win.value), H = S.ftin(f.Hft.value, f.Hin.value);
      if (!(L > 0 && W > 0 && H > 0)) { var er = editor.querySelector('.aos-compare__err'); er.textContent = 'Enter a length, width and ceiling height greater than zero.'; er.hidden = false; f.Lft.focus(); return; }
      r.L = L; r.W = W; r.H = H;
      ['wall', 'glass', 'insulation', 'ceiling'].forEach(function (k) { if (f[k]) r[k] = f[k].value; });
      S.saveRoom(r); editor.hidden = true; render();
      var b = roomEl.querySelector('[data-edit-room]'); if (b) b.focus();
    });
    editor.addEventListener('click', function (e) { if (e.target.closest('[data-cancel]')) { editor.hidden = true; render(); var b = roomEl.querySelector('[data-edit-room]'); if (b) b.focus(); } });
    roomEl.addEventListener('click', function (e) {
      if (!e.target.closest('[data-edit-room]')) return;
      editor.hidden = !editor.hidden; render();
      if (!editor.hidden) { var first = editor.querySelector('input'); if (first) first.focus(); }
    });
    var params = new URLSearchParams(location.search);
    var cat = params.get('type') || ['steam', 'electric', 'wood', 'kit'].filter(function (c) { return C.list(c).length; })[0] || 'steam';

    function room() { var r = S.loadRoom(); return (S.num(r.L) > 0 && S.num(r.W) > 0 && S.num(r.H) > 0) ? r : null; }

    function fitText(p) {
      var r = room(); var s = p.specs || {};
      if (!r || !s.max) return { t: '—', cls: '' };
      var f;
      if (cat === 'steam') f = S.steamFit(S.steam(S.brandKey(p.vendor), r), s.max);
      else f = S.heaterFit(S.heater(r).adjusted, s.min, s.max);
      var cls = f.status === 'fits' || f.status === 'warning' ? 'is-fit' : (f.status === 'unknown' ? '' : 'is-nofit');
      return { t: f.status === 'fits' ? 'Fits' : f.status === 'warning' ? 'Fits (see note)' : f.status === 'small' ? 'Too small' : f.status === 'big' ? 'Too powerful' : f.status === 'consult' ? 'Contact us' : '—', cls: cls };
    }

    function link(p) { return p.chosen ? p.url + '?variant=' + p.variant_id : p.url; }
    function elec(s) { return s.voltage ? String(s.voltage).replace(/,\s*/g, '/') + ' V' + (s.phase ? ', ' + s.phase + '-phase' : '') : '—'; }
    function range(s) { return s.max ? ((S.num(s.min) > 0 ? fmt(s.min) + '–' : 'Up to ') + fmt(s.max) + ' cu. ft.') : '—'; }
    function yes(v) { return v === true || v === 'Yes' || v === 'true'; }

    var ROWS = {
      steam: [['Price', function (p) { return p.price; }], ['Power', function (p) { return p.specs.kw ? p.specs.kw + ' kW' : '—'; }],
        ['Max room size', function (p) { return range(p.specs); }], ['Electrical', function (p) { return elec(p.specs); }],
        ['Amperage', function (p) { return p.specs.amps ? p.specs.amps + ' A' : '—'; }], ['Use', function (p) { return p.specs.application || '—'; }],
        ['Manuals & spec sheets', function (p) { return p.docs ? p.docs + ' PDF' : '—'; }]],
      electric: [['Price', function (p) { return p.price; }], ['Power', function (p) { return p.specs.kw ? p.specs.kw + ' kW' : '—'; }],
        ['Room size', function (p) { return range(p.specs); }], ['Electrical', function (p) { return elec(p.specs); }],
        ['Stones', function (p) { return p.specs.stone_lb ? p.specs.stone_lb + ' lb' : '—'; }], ['Use', function (p) { return p.specs.application || '—'; }],
        ['Manuals & spec sheets', function (p) { return p.docs ? p.docs + ' PDF' : '—'; }]],
      wood: [['Price', function (p) { return p.price; }], ['Output', function (p) { return p.specs.kw ? p.specs.kw + ' kW' : '—'; }],
        ['Room size', function (p) { return range(p.specs); }], ['Stones', function (p) { return p.specs.stone_lb ? p.specs.stone_lb + ' lb' : '—'; }],
        ['Loading', function (p) { return yes(p.specs.external_feed) ? 'From outside the sauna' : 'Inside the sauna'; }],
        ['Water tank', function (p) { return p.specs.water_tank && p.specs.water_tank !== 'None' ? p.specs.water_tank : 'None'; }],
        ['Fireplace (Duo)', function (p) { return yes(p.specs.duo_fireplace) ? 'Yes' : 'No'; }],
        ['Clearance (side / rear)', function (p) { return p.specs.clearance_side_in ? p.specs.clearance_side_in + '" / ' + p.specs.clearance_rear_in + '"' : '—'; }],
        ['Finish', function (p) { return p.specs.finish || '—'; }],
        ['Manuals & spec sheets', function (p) { return p.docs ? p.docs + ' PDF' : '—'; }]]
    };


    // Saunas: specs come from the spec table in each product's description
    var KIT_FIELDS = [
      ['Type', null],
      ['Capacity', ['capacity', 'seating capacity', 'seating']],
      ['Heater', ['sauna heater', 'heaters', 'infrared heaters', 'heater', 'heating source', 'heater requirement', 'compatible heater', 'heater compatibility', 'heating compatibility', 'heating option']],
      ['EMF level', ['emf level']],
      ['Wood', ['wood', 'wood type', 'material', 'exterior lumber']],
      ['Exterior size', ['exterior dimensions (w x d x h)', 'exterior dimensions', 'size', 'dimensions', 'barrel size', 'approx. exterior']],
      ['Interior size', ['interior dimensions (w x d x h)', 'interior dimensions', 'interior volume', 'cubic size']],
      ['Electrical', ['electrical', 'power', 'voltage']],
      ['Temperature', ['temperature range']],
      ['Location', ['location', 'usage', 'installation type', 'environment', 'installation']],
      ['Weight', ['assembled weight', 'weight']],
      ['Warranty', ['warranty']]
    ];
    function kitSpecs(p) {
      if (p.__kit) return p.__kit;
      var map = {};
      try {
        var doc = new DOMParser().parseFromString(p.body || '', 'text/html');
        doc.querySelectorAll('tr').forEach(function (tr) {
          var cells = tr.querySelectorAll('th, td'); if (cells.length < 2) return;
          var k = cells[0].textContent.replace(/\s+/g, ' ').trim().toLowerCase(), v = cells[1].textContent.replace(/\s+/g, ' ').trim();
          if (k && v && !(k in map)) map[k] = v;
        });
      } catch (e) {}
      var t = p.title || '', type = /hybrid/i.test(t) ? 'Hybrid (stove + infrared)' : /full spectrum/i.test(t) ? 'Full spectrum infrared' : /infrared|\bIR\b/i.test(t) ? 'Far infrared' : 'Traditional';
      var out = { Type: type };
      KIT_FIELDS.forEach(function (f) { if (!f[1]) return; for (var i = 0; i < f[1].length; i++) { if (map[f[1][i]]) { out[f[0]] = map[f[1][i]]; break; } } });
      if (!out.Location) out.Location = /outdoor/i.test(t) ? 'Outdoor' : /indoor/i.test(t) ? 'Indoor' : undefined;
      return (p.__kit = out);
    }
    ROWS.kit = [['Price', function (p) { return p.price; }]].concat(KIT_FIELDS.map(function (f) { return [f[0], function (p) { return kitSpecs(p)[f[0]] || '\u2014'; }]; }))
      .concat([['Manuals & spec sheets', function (p) { return p.docs ? p.docs + ' PDF' : '\u2014'; }]]);

    function counts() { tabs.forEach(function (t) { t.querySelector('[data-count]').textContent = C.list(t.getAttribute('data-cat')).length; }); }

    function render() {
      counts();
      tabs.forEach(function (t) { t.setAttribute('aria-selected', t.getAttribute('data-cat') === cat ? 'true' : 'false'); });
      var r = room();
      var note = root.querySelector('.aos-compare__note'); if (note) note.hidden = cat === 'kit';
      if (cat === 'kit') {
        roomEl.innerHTML = '';
        editor.hidden = true;
      } else {
        var vol = r ? fmt(S.num(r.L) * S.num(r.W) * S.num(r.H)) : '';
        roomEl.innerHTML = (r ? 'Your room: ' + vol + ' cu. ft. (' + S.num(r.L) + ' \u00d7 ' + S.num(r.W) + ' \u00d7 ' + S.num(r.H) + ' ft). '
          : 'Add your room to see which ones fit. ') +
          '<button type="button" class="link aos-compare__edit" data-edit-room aria-expanded="' + (!editor.hidden) + '" aria-controls="' + editor.id + '">' + (r ? 'Edit room' : 'Add your room') + '</button>';
        if (!editor.hidden) buildEditor();
      }
      var handles = C.list(cat);
      if (!handles.length) { table.innerHTML = '<p class="aos-compare__empty">Nothing to compare yet. Use “Add to compare” on product pages.</p>'; return; }
      table.innerHTML = '<p class="aos-compare__loading">Loading…</p>';
      Promise.all(handles.map(fetchProduct)).then(function (items) {
        items = items.filter(Boolean);
        var rows = ROWS[cat].slice();
        if (cat !== 'kit') rows.unshift(['Fit for your room', function (p) { return fitText(p); }]);
        var head = '<tr><th scope="col" class="aos-compare__corner">' + items.length + ' product' + (items.length === 1 ? '' : 's') + '</th>' + items.map(function (p) {
          return '<th scope="col">' + (p.img ? '<a href="' + esc(link(p)) + '"><img src="' + esc(p.img) + '" alt="" loading="lazy" width="250" height="250"></a>' : '') +
            '<span class="aos-compare__brand">' + esc(p.vendor) + '</span><a class="aos-compare__name link" href="' + esc(link(p)) + '">' + esc(p.title) + '</a>' +
            (p.variants > 1 && p.variant_title ? '<span class="aos-compare__variant">' + esc(p.variant_title) + '</span>' : '') +
            '<button type="button" class="aos-compare__remove link" data-remove="' + esc(p.key) + '">Remove</button></th>';
        }).join('') + '</tr>';
        var body = rows.map(function (row) {
          var vals = items.map(function (p) { var v = row[1](p); return typeof v === 'object' ? v : { t: v, cls: '' }; });
          var same = vals.every(function (v) { return v.t === vals[0].t; });
          return '<tr class="' + (!same && diff.checked ? 'is-diff' : '') + '"><th scope="row">' + esc(row[0]) + '</th>' +
            vals.map(function (v) { return '<td class="' + v.cls + '">' + esc(v.t) + '</td>'; }).join('') + '</tr>';
        }).join('');
        var buy = '<tr><th scope="row"><span class="visually-hidden">Buy</span></th>' + items.map(function (p) {
          return '<td>' + (p.variants > 1 && !p.chosen ? '<a class="button button--primary button--small" href="' + esc(p.url) + '">Choose options</a>'
            : '<form action="/cart/add" method="post"><input type="hidden" name="id" value="' + esc(p.variant_id) + '"><button class="button button--primary button--small" type="submit"' + (p.available ? '' : ' disabled') + '>' + (p.available ? 'Add to cart' : 'Sold out') + '</button></form>') + '</td>';
        }).join('') + '</tr>';
        table.innerHTML = '<table class="aos-compare__table"><thead>' + head + '</thead><tbody>' + body + buy + '</tbody></table>';
      });
    }

    tabs.forEach(function (t) { t.addEventListener('click', function () { cat = t.getAttribute('data-cat'); history.replaceState(null, '', '?type=' + cat); render(); }); });
    diff.addEventListener('change', render);
    table.addEventListener('click', function (e) { var b = e.target.closest('[data-remove]'); if (b) { C.remove(cat, b.getAttribute('data-remove')); render(); } });
    render();
  }

  function boot() { if (!window.AOS || !window.AOS.compare) return setTimeout(boot, 50); document.querySelectorAll('.aos-compare').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();